import { fetch, strategies } from 'app/utils/data'
import deserialize from 'app/utils/deserialize'

export default {
  namespaced: true,

  state: {
    icon: null
  },

  getters: {
    icon: (state) => state.icon
  },

  mutations: {
    fetched(state, { iconDefinition }) {
      state.icon = iconDefinition
    },

    resetState: (state) => {
      state.icon = null
    }
  },

  actions: {
    async fetch({ commit }, { iconName, version }) {
      try {
        const response = await fetch({
          url: `/api/icon-definitions/${iconName}`,
          params: {
            version
          },
          type: 'icon-definition',
          strategies: [strategies.INLINE, strategies.XHR]
        })
        const iconDefinition = await deserialize(response.data)

        commit('fetched', { iconDefinition })

        return Promise.resolve()
      } catch (e) {
        return Promise.reject(e)
      }
    }
  }
}
